import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/unassigned/${number | ':accountId'}`;

export const ROUTE: RouteDefinition = `${baseRoute}/unassigned/:accountId`;

export const URL = (accountId: number): RouteDefinition =>
	`${baseRoute}/unassigned/${accountId}`;
